import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false
})
export class TextInputComponent {
  @Input() placeholder: string;
  @Input() value: string;
  @Input() maxLength?: number;
  @Output() valueChange = new EventEmitter<string>();
  @Output() submit = new EventEmitter<null>();

  constructor() {}

  onValueChange(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }

  onSubmit(): void {
    this.submit.emit(null);
  }
}
